const PLACEHOLDER_SESSION_IDS = new Set(['mock-session-id', 'e2e-mock-session-id'])

export function isPlaceholderSessionId(sessionId: string): boolean {
  return PLACEHOLDER_SESSION_IDS.has(sessionId)
}
